<!-- Contenedor fijo en la esquina inferior derecha -->
<div class="fixed bottom-6 right-6 z-[999999] flex flex-col gap-3 pointer-events-none">
  @for (toast of toastService.toasts(); track trackById($index, toast)) {
    <div
      class="pointer-events-auto flex w-80 items-start gap-3 rounded-2xl border bg-white px-4 py-3.5 shadow-lg dark:bg-gray-900"
      [ngClass]="{
        'border-success-200 dark:border-success-800': toast.type === 'success',
        'border-error-200 dark:border-error-800':   toast.type === 'error',
        'border-gray-200 dark:border-gray-700':     toast.type === 'info'
      }">

      <!-- Ícono -->
      <div class="mt-0.5 shrink-0">
        @if (toast.type === 'success') {
          <span class="flex size-8 items-center justify-center rounded-full bg-success-50 dark:bg-success-900/30">
            <svg class="size-4 text-success-600 dark:text-success-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"/>
            </svg>
          </span>
        }
        @if (toast.type === 'error') {
          <span class="flex size-8 items-center justify-center rounded-full bg-error-50 dark:bg-error-900/30">
            <svg class="size-4 text-error-600 dark:text-error-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd"/>
            </svg>
          </span>
        }
        @if (toast.type === 'info') {
          <span class="flex size-8 items-center justify-center rounded-full bg-blue-50 dark:bg-blue-900/30">
            <svg class="size-4 text-blue-600 dark:text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd"/>
            </svg>
          </span>
        }
      </div>

      <!-- Texto -->
      <div class="flex-1 min-w-0">
        <p class="text-sm font-semibold text-gray-800 dark:text-white">{{ toast.title }}</p>
        @if (toast.message) {
          <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{{ toast.message }}</p>
        }
      </div>

      <!-- Cerrar -->
      <button (click)="toastService.dismiss(toast.id)"
        class="shrink-0 rounded-lg p-1 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-white/5 dark:hover:text-gray-300">
        <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  }
</div>
